<template>
<div>
    <Header />
    <main>
        <section>
            <div class="container pt-7">
                <div class="row">
                    <div class="col-xl-8 mb-5 mb-xl-0">
                        <h4 class="mb-4">{{ $t('podcast') }}</h4>
                        <div class="card bg-secondary bg-opacity-50 p-3 mb-4" v-for="podcast in podcasts" :key="podcast.id" style="height: 200px;">
                            <div class="row">
                                <div class="col-12">
                                    <iframe :style="{ borderRadius: '16px' }" :src="extractSrc(podcast.iframe_code)" width="100%" height="100" frameborder="0" allowfullscreen allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture" loading="lazy"></iframe>
                                </div>
                                <div class="col-12 mt-3">
                                    <span class="badge bg-primary">{{ podcast.title }}</span>
                                    <span class="badge bg-danger">{{ podcast.category }}</span>
                                </div>
                                <p style="font-size: 14px;">{{ podcast.description }}</p>
                            </div>
                        </div>
                        <div class="text-center" v-if="podcasts.next_page_url">
                            <button @click="loadMore" type="button" class="btn btn-sm btn-secondary">
                                {{ $t('loadMore') }} <i class="bi bi-arrow-down-circle ms-2 align-middle"></i>
                            </button>
                        </div>
                    </div>

                    <div class="col-xl-3 ms-auto">
                        <div class="row">
                            <div class="col-sm-6 col-lg-3 col-xl-12">
                                <div class="card bg-transparent">
                                    <div class="card-header border-bottom bg-transparent px-0">
                                        <p class="lead fw-bold heading-color mb-0">{{ $t('categories') }}</p>
                                    </div>
                                    <div class="card-body px-0">
                                        <ul>
                                            <li v-for="(count, category) in categoryCounts" :key="category">
                                                {{ category }} : ( {{ count }} )
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            <div class="col-sm-6 col-lg-3 col-xl-12">
                                <div class="card bg-transparent">
                                    <div class="card-header border-bottom bg-transparent px-0">
                                        <p class="lead fw-bold heading-color mb-0">{{ $t('followUs') }}</p>
                                    </div>
                                    <div class="card-body px-0">
                                        <ul class="list-inline mb-0 text-center justify-content-center">
                                            <!-- Instagram -->
                                            <li class="list-inline-item">
                                                <a class="btn btn-icon bg-instagram" href="https://www.instagram.com/visennia_/profilecard/?igsh=MXRobGJic2s3anZneA==">
                                                    <i class="bi bi-instagram lh-base"></i>
                                                </a>
                                            </li>
                                            <!-- Facebook -->
                                            <li class="list-inline-item">
                                                <a class="btn btn-icon bg-facebook" href="https://www.facebook.com/profile.php?id=61574224162359">
                                                    <i class="bi bi-facebook lh-base"></i>
                                                </a>
                                            </li>
                                            <!-- TikTok -->
                                            <li class="list-inline-item">
                                                <a class="btn btn-icon bg-tiktok" href="https://www.tiktok.com/@visenniamedia?_t=ZT-8ud6AKxhdTq&_r=1">
                                                    <i class="bi bi-tiktok lh-base"></i>
                                                </a>
                                            </li>
                                        </ul>

                                    </div>
                                </div>
                            </div>

                            <div class="col-sm-6 col-lg-3 col-xl-12">
                                <div class="card bg-transparent">
                                    <div class="card-header border-bottom bg-transparent px-0">
                                        <p class="lead fw-bold heading-color mb-0">{{ $t('popularTags') }}</p>
                                    </div>
                                    <div class="card-body px-0">
                                        <ul class="list-inline mb-0 social-media-btn">
                                            <li class="list-inline-item"> <a class="btn btn-secondary btn-xs" href="#">blog</a> </li>
                                            <li class="list-inline-item"> <a class="btn btn-secondary btn-xs" href="#">business</a> </li>
                                            <li class="list-inline-item"> <a class="btn btn-secondary btn-xs" href="#">data science</a> </li>
                                            <li class="list-inline-item"> <a class="btn btn-secondary btn-xs" href="#">deep learning</a> </li>
                                            <li class="list-inline-item"> <a class="btn btn-secondary btn-xs" href="#">Adventure</a> </li>
                                            <li class="list-inline-item"> <a class="btn btn-secondary btn-xs" href="#">Community</a> </li>
                                            <li class="list-inline-item"> <a class="btn btn-secondary btn-xs" href="#">Tutorials</a> </li>
                                            <li class="list-inline-item"> <a class="btn btn-secondary btn-xs" href="#">Interview</a> </li>
                                            <li class="list-inline-item"> <a class="btn btn-secondary btn-xs" href="#">Photography</a> </li>
                                            <li class="list-inline-item"> <a class="btn btn-secondary btn-xs" href="#">Classic</a> </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </main>
    <Footer />
</div>
</template>

<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import axios from "@/api/axios.js";

export default {
    components: {
        Header,
        Footer
    },
    data() {
        return {
            podcasts: [],
            pagination: {},

            categoryCounts: {},
        }
    },
    mounted() {
        this.fetchPodcasts()
    },
    methods: {
        async fetchPodcasts(url = '/get-podcasts') {
            try {
                const response = await axios.get(url)
                this.podcasts = response.data.data
                this.pagination = response.data
                this.countPodcastsByCategory();
            } catch (error) {
                console.error('Erreur lors du chargement des podcasts', error)
            }
        },
        async loadMore() {
            if (this.pagination.next_page_url) {
                try {
                    const response = await axios.get(this.pagination.next_page_url)
                    this.podcasts = [...this.podcasts, ...response.data.data]
                    this.pagination = response.data
                } catch (error) {
                    console.error('Erreur lors du chargement supplémentaire', error)
                }
            }
        },
        extractSrc(iframe_code) {
            const match = iframe_code.match(/src="([^"]+)"/)
            return match ? match[1] : ''
        },
        countPodcastsByCategory() {
            this.categoryCounts = {};

            this.podcasts.forEach(article => {
                const category = article.category;

                if (this.categoryCounts[category]) {
                    this.categoryCounts[category]++;
                } else {
                    this.categoryCounts[category] = 1;
                }
            });
        },
    }
}
</script>
